import {
  normalizeWorkspaceMark,
  WorkspaceMarkFrame,
  WorkspaceMarkHead,
} from "@repo/workspace-mark";
import { useAuthorizedUser } from "src/features/auth/useAuthorizedUser";
export const WorkspaceMark = ({ appTitle }: { appTitle: string }) => {
  const { currentWorkspace, currentUser } = useAuthorizedUser();
  const { showWorkspaceNameInTitle } = currentUser;
  const mark = normalizeWorkspaceMark(currentWorkspace.mark);
  if (!mark && !showWorkspaceNameInTitle) return null;
  return (
    <>
      <WorkspaceMarkHead
        mark={mark}
        showNameInTitle={showWorkspaceNameInTitle}
        displayName={currentWorkspace.displayName}
        appTitle={appTitle}
      />
      {mark && <WorkspaceMarkFrame mark={mark} />}
    </>
  );
};
